import React, { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { CardLayout } from "./../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "./../../components";

export default function ProductList() {
  const navigate = useNavigate();
  const { userData, token, selectedCompany } = useSelector((state) => state.counter);
  const [selected, setSelected] = useState([]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [screenshot, setScreenshot] = useState(null);
  const [Saving, setSaving] = useState(false);

  // File input ref
  const fileInputRef = useRef(null);

  async function handleOverview() {
    if (!subject || subject.trim() === "") {
      toast.error("Enter subject");
      return;
    }

    if (!message || message.trim() === "") {
      toast.error("Enter message");
      return;
    }

    setSaving(true);

    const formData = new FormData();
    const recipient = selected.map((entry) => entry.value).join(", ");
    formData.append("recipient", recipient);
    formData.append("subject", subject);
    formData.append("message", message);
    if (screenshot) {
      formData.append("screenshot", screenshot);
    }

    try {
      const Response = await axios.post(process.env.REACT_APP_API_URL + "app/dasborad/bug-submitemail", formData, {
        headers: {
          authorization: token,
          "Content-Type": "multipart/form-data",
        },
      });

      if (Response.data.status === "success") {
        toast.success(Response.data.message);
        setSubject("");
        setMessage("");
        setScreenshot(null);
        if (fileInputRef.current) fileInputRef.current.value = ""; // Reset file input
      } else {
        toast.error(Response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setSaving(false);
    }
  }

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <CardLayout>
            <Breadcrumb title={"Submit a Bug"} />
          </CardLayout>
        </Col>
        <Col xl={12}>
          <CardLayout>
            <Row>
              <Col xl={12}>
                <div className="form-group mt-3">
                  <label>Subject</label>
                  <input type="text" className="form-control" value={subject} onChange={(e) => setSubject(e.target.value)} />
                </div>

                <div className="form-group mt-3">
                  <label>Message</label>
                  <SunEditor
                    setOptions={{
                      buttonList: [["undo", "redo"], ["font", "fontSize", "formatBlock"], ["paragraphStyle", "blockquote"], ["bold", "underline", "italic", "strike"], ["fontColor", "hiliteColor"], ["removeFormat"], ["align", "list"], ["link", "table"], ["fullScreen"]],
                    }}
                    onChange={setMessage}
                    setContents={message}
                    height={200}
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Upload Screenshot (optional)</label>
                  <input type="file" className="form-control" accept="image/*" ref={fileInputRef} onChange={(e) => setScreenshot(e.target.files[0])} />
                  {screenshot && (
                    <img
                      src={URL.createObjectURL(screenshot)}
                      alt="Screenshot Preview"
                      className="mt-2"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                    />
                  )}
                </div>

                <button type="button" className="btn btn-primary mt-5" onClick={handleOverview}>
                  {Saving ? <Spinner as="span" animation="grow" size="sm" /> : <>Submit Issue</>}
                </button>
              </Col>
            </Row>
          </CardLayout>
        </Col>
      </Row>
    </PageLayout>
  );
}
